import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import React from "react";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1)
    }
  })
);

export default (props: any) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography
        variant="h3"
        component="h1"
        align="center"
        {...props}
      ></Typography>
    </div>
  );
};
